import React from 'react';
import { useNavigate } from 'react-router-dom';

export default function Sidebar({ isLoggedIn, username, profilePic, onLogout, open = false, onClose }) {
	const navigate = useNavigate();

	const NavButton = ({ onClick, children }) => (
		<button
			onClick={onClick}
			className="w-full text-left px-3 py-2 rounded-md text-sm text-gray-700 hover:bg-blue-50 hover:text-blue-700"
		>
			{children}
		</button>
	);

	if (!open) return null;

	return (
		<div className="fixed left-0 top-0 bottom-0 z-40">
			<aside className="h-full w-56 max-w-[80vw] bg-white border-r border-gray-200 shadow-xl flex flex-col">
				<div className="px-4 py-3 border-b border-gray-100 flex items-center justify-between">
					<div className="text-base font-bold text-blue-700 cursor-pointer" onClick={() => navigate('/')}>DataCreator AI<sup className="text-sm text-blue-600">Beta</sup></div>
					<button onClick={onClose} className="text-gray-400 hover:text-gray-800 text-lg leading-none p-1 block md:hidden" aria-label="Close sidebar">&times;</button>
				</div>
				<div className="flex-1 overflow-y-auto">
					<div className="px-3 py-2 border-b border-gray-100 text-xs font-semibold text-gray-500">Workspace</div>
					<div className="p-2 space-y-1">
						<NavButton onClick={() => navigate('/')}>Home</NavButton>
						<NavButton onClick={() => navigate('/clean')}>Data Cleaner</NavButton>
						{/* <NavButton onClick={() => navigate('/creditinfo')}>Credit Information</NavButton> */}
						<NavButton onClick={() => navigate('/datahistory')}>Data History</NavButton>
						<NavButton onClick={() => navigate('/orders')}>My Custom Orders</NavButton>
					</div>

					<div className="px-3 py-2 border-t border-gray-100 text-xs font-semibold text-gray-500">Resources</div>
					<div className="p-2 space-y-1">
						<NavButton onClick={() => navigate('/blog')}>Blog</NavButton>
						<NavButton onClick={() => navigate('/cdatasets')}>Community Datasets</NavButton>
					</div>
				</div>
				<div className="px-3 py-2 border-t border-gray-100 text-xs font-semibold text-gray-500">Account</div>
				<div className="p-2 space-y-1">
					{isLoggedIn ? (
						<>
							<div className="flex items-center gap-2 px-3 py-2">
								<img src={profilePic || 'https://via.placeholder.com/40'} alt="User" referrerPolicy="no-referrer" className="w-8 h-8 rounded-full border" />
								<div className="leading-tight">
									<div className="text-sm text-gray-800 truncate">{username || 'User'}</div>
									<div className="text-xs text-gray-500">Signed in</div>
								</div>
							</div>
							<NavButton onClick={onLogout}>Logout</NavButton>
						</>
					) : (
						<NavButton onClick={() => navigate('/signin')}>Sign In</NavButton>
					)}
				</div>
			</aside>
		</div>
	);
}